import type { SVGProps } from "react";

export default function NotificationIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
	return (
		<svg
			viewBox="0 0 232.63 305.22"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<g>
				{/* Black parts - use currentColor so they can be controlled via CSS */}
				<path
					fill="currentColor"
					d="M76.32,271.9c-16.51-.08-36.55,1.47-52.54.04-9.95-.89-21.97-10.49-23.37-20.63-2.56-18.51,7.21-30.54,24.97-34.02l-.1-96.93c3.38-36.28,29.27-67.78,63.9-78.6C86.81,23.18,93.77.4,115.92,0c22.41-.4,30.11,23.06,27.53,41.76,34.64,10.82,60.52,42.32,63.9,78.6l-.1,96.93c17.76,3.48,27.53,15.51,24.97,34.02-1.4,10.14-13.43,19.74-23.37,20.63-15.99,1.43-36.03-.12-52.54-.04-5.72,2.5-11.27,2.47-17,0-14.99.8-30.01.8-45,0-6.06,2.47-11.95,2.5-18,0ZM126.32,37.9c.28-7.95,1.57-20.61-9.52-21.07-11.77-.49-10.96,12.87-10.48,21.07h20ZM191.32,217.9v-93.5c0-47.05-51.48-78.74-95.21-67.21-28.13,7.42-54.79,37.18-54.79,67.21v93.5h150ZM23.03,235.11c-9.53,3.39-8.68,18.6,1.76,19.81h183.04c11.2-1.3,11.19-18.75,0-20.04l-184.81.24Z"
				/>
				{/* Green parts - keep fixed colors */}
				<path fill="#33cbcb" d="M94.32,271.9c.87.28.86.62,0,1l1.59.95c7.56,17.4,33.13,16.88,40.91-.05l2.5-.9c-.87-.28-.86-.62,0-1,5.65-.02,11.35.03,17,0-7.84,44.44-72.16,44.43-80,0,5.99.03,12.01-.02,18,0Z" />
				<path fill="#95e3e3" d="M139.32,271.9v1l-1.8,1.97c-14.01.03-28.02.04-42.02.03l-1.17-2v-1c14.98.05,30.02.05,45,0Z" />
			</g>
		</svg>
	);
}

